export const isLocalApi = APP_TYPE === 'static'
